    Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') {
    cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /{{\s*(\w+)\s*}}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
    };

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
            jQuery(".cart-price").html(Shopify.formatMoney(cart.items_subtotal_price));
        });
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
            jQuery(".cart-price").html(Shopify.formatMoney(cart.items_subtotal_price));
        });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    // In this theme is-empty lives on the HOST element (cart-drawer.liquid),
    // not .drawer__inner — clearing only the inner (stock Dawn's location)
    // leaves the empty-state CSS collapsing real rows, so an add into an
    // empty drawer showed totals with no line items. cart.js already toggles
    // the host class on quantity changes; this covers the add path.
    this.classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ── CART PAIRING — "Add" on a suggested product ───────────────────────────
   ⚠ DELEGATED FROM `document` ON PURPOSE. CartDrawer.renderContents() replaces
   #CartDrawer's innerHTML wholesale after every cart change, so a listener
   bound to the button — or an inline <script> inside the drawer — is destroyed
   on the first refresh and silently stops working. innerHTML does not execute
   scripts either. Delegation is the only thing that survives.

   Posts to /cart/add.js, which is the cart AJAX API and not a Shopify form, so
   the store's reCAPTCHA does not apply here — unlike every {% form %} on the
   site. Verified working.

   Only single-variant products render an Add button; anything with a size
   links to its page instead. See snippets/cart-pairing-row.liquid. */
document.addEventListener('click', function (event) {
  var btn = event.target.closest('[data-pair-add]');
  if (!btn) return;

  event.preventDefault();
  if (btn.disabled) return;

  var id = btn.getAttribute('data-variant-id');
  if (!id) return;

  var original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding';

  var drawer = document.querySelector('cart-drawer');
  var body = new FormData();
  body.append('id', id);
  body.append('quantity', '1');
  // Ask for the drawer markup back in the same round trip so the strip, the
  // line items and the total all update together.
  if (drawer && typeof drawer.getSectionsToRender === 'function') {
    body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    body.append('sections_url', window.location.pathname);
  }

  fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: body })
    .then(function (r) { return r.json(); })
    .then(function (state) {
      if (state.status) { throw new Error(state.description || state.message); }
      if (drawer && state.sections) {
        drawer.renderContents(state);
        // Buttons inside the drawer are replaced wholesale by renderContents,
        // but grid quick-adds live outside it and must come back themselves.
        btn.disabled = false;
        btn.textContent = original;
      } else {
        window.location.reload();
      }
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = original;
    });
});

// cdn-roll 10sep
